module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/94e94c7fb012e2c6669d19d2f33f3885.png";